import { render, staticRenderFns } from "./AddFollowupModal.vue?vue&type=template&id=66db0522&"
import script from "./AddFollowupModal.vue?vue&type=script&lang=js&"
export * from "./AddFollowupModal.vue?vue&type=script&lang=js&"
import style0 from "./AddFollowupModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports